import{getArrayIndex}from"./indices.js";


const iterate=(value,{from,to=-0})=>{
const fromIndex=getBoundedIndex(value,from);
const toIndex=Math.max(getBoundedIndex(value,to),fromIndex);
return new Array(toIndex-fromIndex).fill().map((_,index)=>({
value:value[index+fromIndex],
prop:index+fromIndex,
missing:false
}))
};




const getBoundedIndex=(value,edge)=>{
const index=getArrayIndex(value,edge);
return Math.min(index,value.length)
};

export const SLICE_TOKEN={
name:"slice",
valueType:"array",
iterate
};